import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_CONFIG } from '../config/api.config';
import { BaseHttpService } from './base-http.service';
import { extractData } from '../utils/api-response';
import { normalizeNotification, type NotificationItem } from '../types/notification.types';

const NOTIFICATIONS_PATH = API_CONFIG.paths.notifications;

@Injectable({ providedIn: 'root' })
export class NotificationsApiService extends BaseHttpService {
  /** GET /api/Notifications */
  list(): Observable<NotificationItem[]> {
    return this.get<unknown>(NOTIFICATIONS_PATH).pipe(
      map((res) => {
        const data = extractData<unknown>(res);
        let items: unknown[];
        if (Array.isArray(data)) {
          items = data;
        } else if (data != null && typeof data === 'object') {
          const page = data as Record<string, unknown>;
          items = Array.isArray(page['notifications']) ? (page['notifications'] as unknown[]) : [];
        } else {
          items = [];
        }
        return items
          .map((row) => normalizeNotification(row))
          .filter((n): n is NotificationItem => n != null);
      }),
    );
  }

  /** POST /api/Notifications/{notificationId}/read */
  markRead(notificationId: string): Observable<unknown> {
    const id = encodeURIComponent(notificationId.trim());
    return this.post<unknown>(`${NOTIFICATIONS_PATH}/${id}/read`, {});
  }

  /** POST /api/Notifications/read-all */
  markAllRead(): Observable<unknown> {
    return this.post<unknown>(`${NOTIFICATIONS_PATH}/read-all`, {});
  }
}
